<template>
  <div class="sky-page-function-view">
    <div class="sky-page-form">
      <el-form
        ref="thride_server_from"
        class="thride-server-from"
        :model="serverForm"
        :rules="rules"
        label-width="158px"
      >
        <el-form-item class="wsp-padding-tb-6 ">
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="onCancel">取消</el-button>
        </el-form-item>
        <el-form-item label="适配方式" prop="compatibleCheck">
          <el-radio v-model="serverForm.compatibleCheck" label="MANUALLY" value="MANUALLY">人工</el-radio>
          <el-radio v-model="serverForm.compatibleCheck" label="TOOL" value="TOOL">兼容工具</el-radio>
        </el-form-item>
        <el-form-item>
          <div v-if="!isMannually">
            <div class="toolbar-title bg-red el-icon-warning">测试前提前联系客户用工具协助检测后将结果拍照上传</div>
            <div>
              <el-button class="el-icon-download" type="text" @click="downCheckTool()">
                服务器配置检测工具下载
              </el-button>
              <el-button class="el-icon-arrow-right" type="text" @click="openPeUrl">
                云桌面第三方服务器检测工具（PE）使用手册
              </el-button>
            </div>
          </div>
          <div v-else>
            <el-button type="text" @click="openCheckUrl">第三方服务器支持规格</el-button>
          </div>
        </el-form-item>
        <el-form-item label="使用场景" prop="sceneId">
          <el-select v-model="serverForm.sceneId" default-first-option>
            <el-option
              v-for="item in scenes"
              :key="item.sceneId"
              :label="item.sceneName"
              :value="item.sceneId"
            ></el-option>
          </el-select>
          <div class="font-size-10 font-weight-300">请选择使用的场景</div>
        </el-form-item>
        <el-form-item label="服务器型号" prop="serverName">
          <el-input v-model="serverForm.serverName" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">例如：DELL R740</div>
        </el-form-item>
        <el-form-item v-if="!isMannually" label="兼容工具图片" prop="compatibleResultImg">
          <el-upload
            list-type="picture"
            action=""
            accept=".jpg, .png"
            :limit="1"
            :auto-upload="false"
            :file-list="serverForm.compatibleResultImgFile"
            :on-change="getFile"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleUploadRemove"
          >
            <el-button size="small" type="primary">选择图片上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传一张jpg/png文件</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item v-if="isMannually" label="适配结论" prop="compatibleResult" style="margin-top:9px">
          <el-radio v-model="serverForm.compatibleResult" label="YES" value="YES">适配</el-radio>
          <el-radio v-model="serverForm.compatibleResult" label="NO" value="NO">不适配</el-radio>
        </el-form-item>
        <el-form-item
          v-if="isMannually && serverForm.compatibleResult == 'NO'"
          label="不适配理由"
          prop="compatibleMsg"
          style="margin-bottom:15px !important"
        >
          <el-input v-model="serverForm.compatibleMsg" type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item v-if="isMannually" label="是否国产化" prop="type">
          <el-select v-model="serverForm.type" default-first-option>
            <el-option
              v-for="item in serverVendorTypes"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
          <div class="font-size-10 font-weight-300">请选择是否国产化</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="CPU型号" prop="cpu">
          <el-input v-model="serverForm.cpu" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">例如：i5-13490F</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="CPU主频" prop="cpuFrequency">
          <el-input-number v-model="serverForm.cpuFrequency" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写CPU主频，单位：GHz</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="CPU核数" prop="cpuCore">
          <el-input-number v-model="serverForm.cpuCore" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写核数</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="CPU总线程数" prop="cpuTotalThreads">
          <el-input-number v-model="serverForm.cpuTotalThreads" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写CPU的线程总数</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="内存(G)" prop="memory">
          <el-input-number v-model="serverForm.memory" :min="0"></el-input-number>
          <div class="font-size-10 font-weight-300">请填写内存大小，单位:G</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="网卡信息" prop="nicsInfo">
          <el-input v-model="serverForm.nicsInfo" custom-auto-focus></el-input>
          <div class="font-size-10 font-weight-300">请填写网卡信息</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="硬盘信息" prop="memory">
          <div>
            <div class="wsp-display-flex cusotm-header-header">
              <div class="wsp-width-10">
                <el-button type="text"></el-button>
              </div>
              <div class="wsp-width-20 hader-item">
                硬盘类型
              </div>
              <div class="wsp-width-35 hader-item">
                磁盘数量
              </div>
              <div class="wsp-width-35 hader-item">
                单盘大小(G)
              </div>
            </div>
            <div class="wsp-display-flex" v-for="(diskItem, index) in serverForm.diskConfigList" :key="index">
              <div class="wsp-width-10">
                <el-button type="text" @click="removeDiskItem(index)" icon="el-icon-delete"></el-button>
              </div>
              <div class="wsp-width-20">
                <el-select default-first-option v-model="diskItem.type">
                  <el-option label="SSD" value="SSD"></el-option>
                  <el-option label="HDD" value="HDD"></el-option>
                </el-select>
              </div>
              <div class="wsp-width-35">
                <el-input-number :min="0" v-model="diskItem.count" @change="calcDiskSize"></el-input-number>
              </div>
              <div class="wsp-width-35">
                <el-input-number v-model="diskItem.size" :min="0" @change="calcDiskSize"></el-input-number>
              </div>
            </div>
            <div><el-button type="text" @click="addDiskItem" icon="el-icon-plus">添加</el-button></div>
          </div>

          <!-- <el-input-number v-model="serverForm.diskCount" min="0"></el-input-number> -->
          <div class="font-size-10 font-weight-300">请填写硬盘数</div>
        </el-form-item>
        <el-form-item v-if="isMannually" label="磁盘数量(槽位)" prop="diskInfo">
          <el-input-number v-model="serverForm.diskCount" :min="0" disabled></el-input-number>
          <div class="font-size-10 font-weight-300">当前硬盘的数量(由磁盘信息计算得出)</div></el-form-item
        >
        <el-form-item v-if="isMannually" label="硬盘大小(G)" prop="diskInfo">
          <el-input-number v-model="serverForm.diskSize" :min="0" disabled></el-input-number>
          <div class="font-size-10 font-weight-300">当前硬盘的大小(由磁盘信息计算得出)</div></el-form-item
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { Form, FormItem, Input, InputNumber, Button, Select, Option, Radio, Upload, Dialog } from 'element-ui'

import { getServerList } from '@/api/server'
import { getCheckTool } from '@/utils/pageUtils'

// import lang from '@/lang'
export default {
  name: 'SkyThrideServerForm',
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [InputNumber.name]: InputNumber,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [Upload.name]: Upload,
    [Dialog.name]: Dialog
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    scenes: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data: function() {
    return {
      rules: {
        sceneId: [{ required: true, message: '请选择使用的场景', trigger: 'change' }],
        serverName: [{ required: true, message: '请输入服务器型号', trigger: 'blur' }],
        cpu: [{ required: true, message: '请输入CPU型号', trigger: 'blur' }],
        cpuFrequency: [{ required: true, message: '请输入CPU主频', trigger: 'blur' }],
        cpuTotalThreads: [{ required: true, message: '请输入CPU线程数', trigger: 'blur' }],
        type: [{ required: true, message: '请选择是否国产化', trigger: 'change' }],
        compatibleResult: [{ required: true, message: '请选择适配结论', trigger: 'change' }],
        compatibleMsg: [{ required: true, message: '请输入不适配理由', trigger: 'blur' }],
        compatibleResultImg: [{ required: true, message: '请输入上传图片', trigger: 'blur' }]
      },
      serverVendorTypes: [
        {
          id: 'CHINA',
          label: '是'
        },
        { id: 'OTHER', label: '否' }
      ],
      serverForm: {
        sceneId: this.scenes.length > 0 ? this.scenes[0].sceneId : null,
        diskConfigList: [
          {
            type: 'SSD',
            count: 1,
            size: 240
          }
        ],
        serverName: null,
        nicsInfo: null,
        type: null,
        cpuCore: 0,
        cpu: null,
        memory: 0,
        diskSize: 240,
        cpuTotalThreads: 0,
        diskCount: 1,
        compatibleCheck: 'MANUALLY',
        compatibleResult: null,
        compatibleMsg: null,
        compatibleResultImgFile: [],
        compatibleResultImg: null
      },
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: null
    }
  },
  watch: {
    'serverForm.compatibleCheck'(val) {
      this.$refs.thride_server_from.clearValidate()
    }
  },
  computed: {
    isMannually() {
      return this.serverForm.compatibleCheck == 'MANUALLY'
    }
  },
  mounted() {
    this.getData()
  },
  created() {
    if (this.scenes.length > 0) {
      this.selectScene = this.scenes[0]
    }
  },
  methods: {
    getData() {
      var req_data = {
        exactMatchArr: [],
        matchArr: [],
        page: this.page,
        limit: this.pageSize
      }
      getServerList(req_data).then(res => {
        this.listData = res.data.content.itemArr
        this.pageTotal = res.data.content.total
      })
    },
    onSubmit() {
      this.$refs.thride_server_from.validate(valid => {
        if (this.serverForm.compatibleCheck == 'TOOL') {
          this.serverForm.compatibleResult = 'IMG'
        }
        if (valid) {
          this.$emit('addSelect', { select: this.serverForm, sceneId: this.serverForm.sceneId, type: 'ThrideServer' })
        } else {
          this.$emit('unSelect', { select: this.serverForm, sceneId: this.serverForm.sceneId, type: 'ThrideServer' })
          return false
        }
      })
    },
    onCancel() {
      this.$parent.$parent.closerDrawer()
    },
    calcDiskSize() {
      var diskSize = 0
      var diskCont = 0
      for (const iterator of this.serverForm.diskConfigList) {
        var item = iterator.count * iterator.size
        diskCont = iterator.count + diskCont
        diskSize = diskSize + item
      }
      this.serverForm.diskCount = diskCont
      this.serverForm.diskSize = diskSize
    },
    removeDiskItem(index) {
      this.serverForm.diskConfigList.splice(index, 1)
      this.serverForm.diskCount = this.serverForm.diskConfigList.length
      this.calcDiskSize()
    },
    addDiskItem() {
      this.serverForm.diskConfigList.push({
        type: 'SSD',
        count: 1,
        size: 240
      })
      this.serverForm.diskCount = this.serverForm.diskConfigList.length
      this.calcDiskSize()
    },
    getFile(file, fileList) {
      this.getBase64(file.raw).then(res => {
        this.serverForm.compatibleResultImg = res
      })
    },
    // 获取图片转base64
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function() {
          imgResult = reader.result
        }
        reader.onerror = function(error) {
          reject(error)
        }
        reader.onloadend = function() {
          resolve(imgResult)
        }
      })
    },
    handleUploadRemove(file, fileList) {
      this.serverForm.compatibleResultImg = ''
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    downCheckTool() {
      getCheckTool()
    },
    openPeUrl() {
      window.open('https://ruijie.feishu.cn/docx/ULundPvDyoeuW2x43Egcwz6cnLb', '_blank')
    },
    openCheckUrl() {
      window.open('https://ruijie.feishu.cn/wiki/KerswGDTLiwWvkkWwNMcMO0Qnnf', '_blank')
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 87% !important;
  overflow-y: auto;
  .sky-page-form {
    width: 65%;
    .thride-server-from {
      .el-form-item {
        margin-bottom: 0 !important;
      }
      .cusotm-header-header {
        text-align: center;
        line-height: 24px;
        color: #9d9696;
      }
    }
  }
}
</style>
